export default __webpack_public_path__ + "static/media/save.5e67004d.svg";